/**
 * Lightweight and easy to use translation library.
 *
 * @packageDocumentation
 */
/* istanbul ignore file */
import { registerLibrary } from '@onviobr/app-information';
export { TranslationManager, translationManager } from './translation.js';
export { jsonHttpLoader } from './loaders.js';
export { ngxTranslateCodeSynchronizer } from './synchronizers.js';
export { translationNgProvider } from './ng-injector.js';
registerLibrary({
    name: '@onviobr/translation',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "2.1.0",
});
